import {injectable, inject} from "inversify";
import type {AxiosResponse} from "axios";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import {Bindings} from "data/constants/bindings";
import {IPool, IChallenge} from "data/stores/h2h/h2h.store";
import {IChallengesResponse, IInvitationsResponse} from "data/types/h2h";

export interface IH2hProvider {
	joinToPool: (contestId: number) => Promise<AxiosResponse<IApiResponse<{pool: IPool}>>>;
	getChallenges: (contestId: number) => Promise<AxiosResponse<IApiResponse<IChallengesResponse>>>;
	getInvitations: (
		contestId: number
	) => Promise<AxiosResponse<IApiResponse<IInvitationsResponse>>>;
	challengeByPool: (
		poolId: number
	) => Promise<AxiosResponse<IApiResponse<{challenge: IChallenge}>>>;
	inviteFriendToPlay: (
		contestId: number,
		friendId: number
	) => Promise<AxiosResponse<IApiResponse<{challenge: IChallenge}>>>;

	view: (inviteId: number) => Promise<AxiosResponse<IApiResponse>>;
	delete: (inviteId: number) => Promise<AxiosResponse<IApiResponse>>;
	accept: (inviteId: number) => Promise<AxiosResponse<IApiResponse>>;
}

@injectable()
export class H2hProvider implements IH2hProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}
	public joinToPool = (contestId: number) =>
		this._http.post<IApiResponse<{pool: IPool}>>(`h2h/${contestId}/pool/join`);
	public getChallenges = (contestId: number) =>
		this._http.get<IApiResponse<IChallengesResponse>>(`h2h/${contestId}/challenges`);
	public getInvitations = (contestId: number) =>
		this._http.get<IApiResponse<IInvitationsResponse>>(`h2h/${contestId}/invitations`);
	public challengeByPool = (poolId: number) =>
		this._http.get<IApiResponse<{challenge: IChallenge}>>(`h2h/challenge-by-pool/${poolId}`);
	public inviteFriendToPlay = (contestId: number, friendId: number) =>
		this._http.post<IApiResponse<{challenge: IChallenge}>>(
			`h2h/${contestId}/invite-friend/${friendId}`
		);

	public view = (inviteId: number) => {
		return this._http.post<IApiResponse>(`h2h/challenge/${inviteId}/view`);
	};

	public delete = (inviteId: number) => {
		return this._http.post<IApiResponse>(`h2h/challenge/${inviteId}/delete`);
	};

	public accept = (inviteId: number) => {
		return this._http.post<IApiResponse>(`h2h/challenge/${inviteId}/accept`);
	};
}
